import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as turf from '@turf/turf';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { environment } from '../../../../environments/environment';
import { Equipment, Field, StoreModel } from '../../_models';
import { FarmService } from '../farm.service';
import { StoreModelService } from '../storeModel.service';
import { GeneralUtilsService } from '../common/generalUtils.service';

@Injectable()
export class MachineUtilitiesService {
  private telemetryBaseUrl = environment.telemetryServiceUrl;
  private storeModels: Array<StoreModel> = [];

  constructor(
    private http: HttpClient,
    private farmService: FarmService,
    private generalUtilsService: GeneralUtilsService,
    private storeModelService: StoreModelService
  ) {
    this.storeModelService.list.subscribe((storeModelsList) => {
      this.storeModels = storeModelsList;
    });
  }

  checkTelemetryByFarm(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SDFBTM' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SDFCTM' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_COBO_COBOMASTER' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_TEYME' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_YNNOVA' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_NON_ARAG_YNNOVA' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_COBO_XFARMMASTER' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_GEOTAB' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNH_PREMIUM' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNH_BLUE_PREMIUM' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_AGRIROUTER' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLAAS' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_AMASLIMT4' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SMART2' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_WAY' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_GOLDONI' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_PFN' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_MATERMACC' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLIMATE_FIELDVIEW' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_JOHN_DEERE' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNHMAP' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_TRAKMATE' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_ALLYNAV' &&
          this.storeModelService.isStoreModelProActive(storeModel))
      );
    });

    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderGeoTabActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_GEOTAB' ||
          storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNH_PREMIUM' ||
          storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNH_BLUE_PREMIUM') &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderCoboInTouchActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_COBO_COBOMASTER' &&
          this.storeModelService.isStoreModelProActive(storeModel)) ||
        (storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_COBO_XFARMMASTER' &&
          this.storeModelService.isStoreModelProActive(storeModel))
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderSdfBtmActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SDFBTM' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderSdfCtmActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SDFCTM' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderTeymeActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_TEYME' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderAragYnnovaActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_YNNOVA' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderYnnovaActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_NON_ARAG_YNNOVA' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderAgrirouterActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_AGRIROUTER' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderClaasActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLAAS' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderClaasConnectActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLAAS_CONNECT' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderAmaslimt4Active(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_AMASLIMT4' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderSmart2Active(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_SMART2' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderWayActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_WAY' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderGoldoniActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_GOLDONI' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderMaterMaccActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_MATERMACC' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderClimateFieldViewActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CLIMATE_FIELDVIEW' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderJohnDeereActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_JOHN_DEERE' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderPFNActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_PFN' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderCNHActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_CNHMAP' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderTrakmateActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_TRAKMATE' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  isTelemetryProviderAllynavActive(): boolean {
    const telemetryProvider: Array<StoreModel> = this.storeModels.filter((storeModel) => {
      return (
        storeModel.roleGranted == 'SM_EQUIPMENT_TELEMETRY_ALLYNAV' &&
        this.storeModelService.isStoreModelProActive(storeModel)
      );
    });
    return telemetryProvider && telemetryProvider.length > 0;
  }

  checkTelemetryByEquipment(equipment: Equipment): boolean {
    if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH_PFN'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH_ARVATEC'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH_TEYME'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH_AGRO'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'COBOINTOUCH_INDUSTRIAL'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'GEOTAB'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'SDFBTM'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'SDFCTM'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'FADE'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'AMASLIMT4'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'CNHGPS'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'WAY'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'GOLDONI'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'AMASLIMT4'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'MATERMACC'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'CLAAS'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'CLIMATEFIELDVIEW'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'JOHN_DEERE'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'CNHMAP'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'ARAG_YNNOVA'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'TRAKMATE'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'ALLYNAV'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'YNNOVA'])
    ) {
      return true;
    } else if (
      equipment &&
      equipment.externalResources &&
      _.find(equipment.externalResources, ['externalSource', 'CLAAS_CONNECT'])
    ) {
      return true;
    } else {
      return false;
    }
  }

  /*  		getProviderFromFarm(farm): String {
				switch (farm.externalSourceOwnership) {
						case 'XFARM_MASTER_COBOINTOUCH': {
								return "COBOINTOUCH";
						}
						case 'COBO_MASTER_COBOINTOUCH': {
								return "COBOINTOUCH";
						}
						case 'XFARM_MASTER_GEOTAB': {
								return "GEOTAB";
						}
						case 'XFARM_MASTER_SDFBTM': {
							return "SDFBTM";
						}
						case 'FADE': {
							return "FADE";
						}
						default:
								return null;
				}
		}
 */
  findProviderByCompanyId(companyId: number): string {
    this.farmService.setFarmParamByID(companyId, 'externalSourceOwnership');
    const externalSourceOwnership = this.farmService.getFarmByParam();
    return externalSourceOwnership ? externalSourceOwnership : null;
  }

  findField(fieldList: Array<any>, point: Array<any>): Field {
    if (!fieldList || fieldList === undefined) {
      return null;
    }
    let result: Field;
    fieldList.forEach((field) => {
      if (
        field &&
        field.geoJsonArea &&
        this.generalUtilsService.getValidateJsonString(field.geoJsonArea)
      ) {
        const ccc = JSON.parse(field.geoJsonArea);
        const coords = ccc.features[0].geometry.coordinates[0];
        coords.push(coords[0]);
        const pt = turf.point([point[0], point[1]]);
        const poly = turf.polygon([coords]);

        const resultBool = turf.booleanPointInPolygon(pt, poly);
        if (resultBool) {
          result = field;
          return result ? result : null;
        }
      }
    });

    return result ? result : null;
  }

  getListDateEquipmentLocation(
    equipmentId,
    startDate,
    endDate,
    externalSource = null,
    externalId = null
  ): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryBaseUrl +
          'api/equipmentTelemetry/getListDateEquipmentLocations?equipmentId=' +
          equipmentId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
